module.exports = __webpack_public_path__ + "static/media/home5.3f3b452d.jpg";